import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
} from "react";

// Context for form file uploads and error ids

type FormResponsesContextType = {
  formFileUploads: Record<string, string>;
  setFormFileUploads: Dispatch<SetStateAction<Record<string, string>>>;
  formErrorIds: string[];
  setFormErrorIds: Dispatch<SetStateAction<string[]>>;
};

const FormResponsesContext = createContext<FormResponsesContextType | null>(
  null
);

type ProviderProps = FormResponsesContextType & {
  children: ReactNode;
};

export const FormResponsesProvider = (props: ProviderProps) => {
  const {
    children,
    formFileUploads,
    setFormFileUploads,
    formErrorIds,
    setFormErrorIds,
  } = props;
  return (
    <FormResponsesContext.Provider
      value={{
        formFileUploads,
        setFormFileUploads,
        formErrorIds,
        setFormErrorIds,
      }}
    >
      {children}
    </FormResponsesContext.Provider>
  );
};

export const useFormResponsesContext = () => {
  const ctx = useContext(FormResponsesContext);
  if (!ctx) {
    throw new Error(
      "useFormResponsesContext must be used within FormResponsesProvider"
    );
  }
  return ctx;
};
